import { render, staticRenderFns } from "./ConfigureWarp.vue?vue&type=template&id=f97c6710&scoped=true"
import script from "./ConfigureWarp.vue?vue&type=script&lang=js"
export * from "./ConfigureWarp.vue?vue&type=script&lang=js"
import style0 from "./ConfigureWarp.vue?vue&type=style&index=0&id=f97c6710&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_6m5rqjauvbyej62p7eiecas4wq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97c6710",
  null
  
)

export default component.exports